<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <!-- <b-card header-tag="header" header-bg-variant="dark"> -->
      <div>
        <!-- <template #header>
          <h5 class="mb-0" style="color: #fff">
            <strong>{{ $store.state.table.mutasi }}</strong>
          </h5>
        </template> -->
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalMutasi-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalMutasi" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    v-if="item.statusMutasi == 0"
                    variant="success"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Aktifkan Mutasi'"
                    v-b-modal.modal-aktivasi-jabatan
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-check"
                  /></b-button>
                  <b-button
                    v-if="item.statusMutasi == 0"
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete-mutasi-jabatan
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-trash"
                  /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </div>
    </CCol>
    <CCol col="12">
      <b-modal id="modal-aktivasi-jabatan" size="lg" centered scrollable title="Konfirmasi Mutasi" header-bg-variant="info" header-text-variant="light">
        <p>
          Apakah anda yakin akan Melakukan Mutasi {{ data.jenisMutasi }} a.n
          <span class="text-success">{{ data.namaKaryawan }}</span>
          dari
          <span class="text-success" v-if="data.jenisMutasi == 'Jabatan'">{{ data.jabatanAwal }}</span>
          <span class="text-success" v-if="data.jenisMutasi == 'Penempatan'">{{ data.penempatanAwal }}</span>
          ke
          <span class="text-success" v-if="data.jenisMutasi == 'Jabatan'">{{ data.jabatanBaru }}</span>
          <span class="text-success" v-if="data.jenisMutasi == 'Penempatan'">{{ data.penempatanBaru }}</span>
          ?
        </p>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-aktivasi-jabatan')"> Batal </b-button>
          <b-button variant="primary" @click="aktifkan()" :disabled="busy"> Yakin </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-delete-mutasi-jabatan" size="lg" centered scrollable title="Konfirmasi Hapus Mutasi" header-bg-variant="info" header-text-variant="light">
        <p>
          Apakah anda yakin akan
          <span class="text-danger">Membatalkan</span> Mutasi {{ data.jenisMutasi }} a.n
          <span class="text-danger">{{ data.namaKaryawan }}</span>
          dari
          <span class="text-danger" v-if="data.jenisMutasi == 'Jabatan'">{{ data.jabatanAwal }}</span>
          <span class="text-danger" v-if="data.jenisMutasi == 'Penempatan'">{{ data.penempatanAwal }}</span>
          ke
          <span class="text-danger" v-if="data.jenisMutasi == 'Jabatan'">{{ data.jabatanBaru }}</span>
          <span class="text-danger" v-if="data.jenisMutasi == 'Penempatan'">{{ data.penempatanBaru }}</span>
          ?
        </p>
        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-delete-mutasi-jabatan')"> Batal </b-button>
          <b-button variant="primary" @click="hapusMutasi()" :disabled="busy"> Yakin </b-button>
        </template>
      </b-modal>
    </CCol>
  </CRow>
</template>

<script>
export default {
  components: {},
  props: ["news", "refresh"],
  name: "mutasi",
  data() {
    return {
      data: {},
      items: [],

      filter: {
        tanggalMutasi: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      busy: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "jenisMutasi",
          label: this.$store.state.table.jenisMutasi,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalMutasi",
          label: this.$store.state.table.namaTanggalMutasi,
          _style: "max-width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "jabatanAwal",
          label: this.$store.state.table.jabatanAwal,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "jabatanBaru",
          label: this.$store.state.table.jabatanBaru,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.actions,
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
    },
  },
  mounted() {
    if (this.$store.state.role_aktif.kodeRole == "super") {
      this.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    this.getDatas();
  },
  watch: {
    news(oldVal, newVal) {
      if (oldVal != newVal) {
        this.getDatas();
      }
    },
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalMutasi"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    refresh(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listMutasi = await vm.$axios.post("mutasi/listPerHalaman", {
        ...vm.filter,
        tanggalMutasi: vm.filter.tanggalMutasi ? vm.$moment(vm.filter.tanggalMutasi).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        jenisMutasi: "Jabatan",
      });
      console.log("listMutasiss", listMutasi);
      vm.items =
        listMutasi.data.status == 200
          ? listMutasi.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.mutasiId,
                namaMitra: x.namaMitra || " - ",
                jabatanAwal: x.jabatanAwal ? x.jabatanAwal : " - ",
                jabatanBaru: x.jabatanBaru ? x.jabatanBaru : " - ",
                penempatanAwal: x.penempatanAwal ? x.penempatanAwal : " - ",
                penempatanBaru: x.penempatanBaru ? x.penempatanBaru : " - ",
                namaTanggalMutasi: vm.$moment(x.tanggalMutasi).format("LL"),
                jenisMutasi: "Jabatan",
              };
            })
          : [];
      vm.totalRows = parseInt(listMutasi.data.count);
      vm.loading = false;
    },
    aktifkan() {
      let vm = this;
      let links = "";
      if (vm.data.jenisMutasi == "Jabatan") {
        links = "suratPerjanjianKerja/aktifkanMutasi";
      } else if (vm.data.jenisMutasi == "Penempatan") {
        links = "poolKontrak/aktifkanMutasi";
      }
      // console.log(vm.data, "aktif");
      vm.$axios
        .post(links, vm.data)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-aktivasi-jabatan");
              vm.busy = false;
              vm.getDatas();
              vm.$emit("change");
              vm.triggerAlert({
                variant: "success",
                msg: "BERHASIL MENGAKTIFKAN MUTASI",
                showing: true,
              });
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.triggerAlert({
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
    hapusMutasi() {
      let vm = this;
      let links = "";
      if (vm.data.jenisMutasi == "Jabatan") {
        links = "suratPerjanjianKerja/deleteMutasi";
      } else if (vm.data.jenisMutasi == "Penempatan") {
        links = "poolKontrak/deleteMutasiPenempatan";
      }
      // console.log(vm.data);
      vm.busy = true;
      vm.$axios
        .post(links, vm.data)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-delete-mutasi-jabatan");
              vm.busy = false;
              vm.getDatas();
              vm.$emit("change");
              vm.triggerAlert({
                variant: "success",
                msg: "BERHASIL MEMBATALKAN MUTASI",
                showing: true,
              });
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.triggerAlert({
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
